export enum Report {
	SectionReport,
	SectionTreeReport
}
